import {
  CREDIT_CARD,
  INVOICE,
  PaymentMethodTypes,
  PAYPAL_CHECKOUT,
  PRZELEWY24
} from '@constants/paymentMethods'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Button } from '@ui-kit'
import { useTranslation } from 'react-i18next'

import { BUTTONS_DATA_TEST_IDS } from '../constants'

export const useGetPaymentButton = () => {
  const { t } = useTranslation()

  const { formik, isFormFilled } = useCheckoutContext()

  const { dirty, isValid, isSubmitting, values, handleSubmit } = formik

  const { paymentMethod } = values

  type PaymentButtonsTypes = {
    name: string
    icon?: string
    dataTestId: string
  }

  const paymentButtons: Record<PaymentMethodTypes, PaymentButtonsTypes> = {
    [CREDIT_CARD]: {
      name: t('checkout.payment.payment.button.pay.now'),
      dataTestId: BUTTONS_DATA_TEST_IDS.CREDIT_CARD
    },
    [PAYPAL_CHECKOUT]: {
      name: t('checkout.payment.payment.button.paypal'),
      icon: 'icon-external-link-alt',
      dataTestId: BUTTONS_DATA_TEST_IDS.PAYPAL
    },
    [PRZELEWY24]: {
      name: t('checkout.payment.payment.button.przelewy24'),
      icon: 'icon-external-link-alt',
      dataTestId: BUTTONS_DATA_TEST_IDS.PRZELEWY24
    },
    [INVOICE]: {
      name: t('checkout.payment.payment.button.invoice'),
      icon: 'icon-external-link-alt',
      dataTestId: BUTTONS_DATA_TEST_IDS.INVOICE
    }
  }

  const button = paymentButtons[paymentMethod]

  const isNotFormValid = isFormFilled ? !isValid : !dirty || !isValid

  return (
    <Button
      onClick={() => handleSubmit()}
      fullWidth
      disabled={isNotFormValid || isSubmitting}
      data-testid={button?.dataTestId}
      icon={button?.icon}
      isLoading={isSubmitting}
    >
      {button.name}
    </Button>
  )
}
